<template>
	<download-excel ref="downloadExcel" :fetch="fetch" :class="cssclass" :data="items" :fields="fields" :name="excelFileName">
		<v-btn v-if="useButton" :loading="loading" fab outlined small color="pink" title="دانلود اکسل">
			<v-icon>
				{{excelIcon}}
			</v-icon>
			<span v-if="title">
				{{title}}
			</span>
		</v-btn>
		<slot />
	</download-excel>
</template>

<script>
	export default {
		name: 'ExportExcel',

		props: {
			fetch: { type: Function },
			loading: { type: Boolean, default: false },
			useButton: { type: Boolean, default: true },
			cssclass: String,
			fileName: String,
			icon: String,
			headers: Array,
			items: Array,
		},
		computed: {
			title() {
				return ''
			},
			excelIcon() {
				return this.icon || 'mdi-microsoft-excel'
			},
			excelFileName() {
				return this.fileName || 'report.xls'
			},
			fields() {
				let fields = {}
				for (let header of this.headers) {
					if (!header.value && !header.excel_value)
						continue
					if (typeof header.excel_callback === 'function') {
						fields[header.text.replaceAll(' ', '_')] = {
							field: header.excel_value || header.value,
							callback: header.excel_callback
						}
						if (fields[header.text.replaceAll(' ', '_')].field === '%root%')
							fields[header.text.replaceAll(' ', '_')].field = ''
					} else {
						fields[header.text.replaceAll(' ', '_')] = header.excel_value || header.value
					}
				}
				return fields
			}
		},
		methods: {
			export(){
				console.log("🚀 ~ export ~ this.$refs.downloadExcel.$el:", this.$refs.downloadExcel.$el)
				this.$refs.downloadExcel.$el.click()
			}
		}
	}
</script>
